import PropTypes from 'prop-types';
import useTabsRouting from '../../hooks/useTabsRouting';

const TabsRoutingWrapper = ({ options }) => {
  const { renderRoutes } = useTabsRouting(options);
  return renderRoutes();
};

TabsRoutingWrapper.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      path: PropTypes.string,
      icon: PropTypes.element,
      component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.array,
      ]),
    }),
  ).isRequired,
};

export default TabsRoutingWrapper;
